import { useMutation } from '@tanstack/react-query';
import { MEAL_PLAN_DETAILED_LOG_PREFIX } from '@web-app/utils/api/logger-prefixes';

export interface GenerateDetailedMealPlanParams {
  dailyRoomName: string;
  healthieClientId?: number;
  healthieProviderId?: number;
}

const generateDetailedMealPlan = async (
  params: GenerateDetailedMealPlanParams,
): Promise<void> => {
  const { dailyRoomName, healthieClientId, healthieProviderId } = params;

  const queryParams = new URLSearchParams();
  if (healthieClientId)
    queryParams.set('healthieClientId', String(healthieClientId));
  if (healthieProviderId)
    queryParams.set('healthieProviderId', String(healthieProviderId));
  const qs = queryParams.toString();

  const res = await fetch(
    `/api/meal-plan/${dailyRoomName}/generate-detailed-meal-plan${qs ? `?${qs}` : ''}`,
    {
      method: 'POST',
    },
  );

  if (!res.ok) {
    const err = await res.json();
    const defaultMsg = 'Failed to generate meal plan recipes';
    const errMsg = err?.error || defaultMsg;

    console.error(`${MEAL_PLAN_DETAILED_LOG_PREFIX} - ${defaultMsg}`, {
      errMsg,
      err,
    });

    return Promise.reject(errMsg);
  }

  return res.json();
};

export const useGenerateDetailedMealPlan = () =>
  useMutation({
    mutationFn: (params: GenerateDetailedMealPlanParams) =>
      generateDetailedMealPlan(params),
  });
